import { useEffect, useState } from 'react';

function fit(width: number, height: number): number {
  return Math.min(window.innerWidth / width, window.innerHeight / height);
}

/** Scale factor that letterboxes a fixed `width`×`height` design canvas into the viewport. */
export function useStageScale(width: number, height: number): number {
  const [scale, setScale] = useState(() => fit(width, height));

  useEffect(() => {
    const onResize = () => setScale(fit(width, height));
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [width, height]);

  return scale;
}
